const cache = new Map();

function getNumberFormatter(lang: string, currency: string, digits = 0) {
	if (!cache.has(lang)) {
		cache.set(lang, new Map());
	}

	const currencies = cache.get(lang);
	if (!currencies.has(`${currency}-${digits}`)) {
		currencies.set(
			`${currency}-${digits}`,
			new Intl.NumberFormat(lang, {
				style: 'currency',
				currency,
				maximumFractionDigits: digits,
				minimumFractionDigits: 0,
			}),
		);
	}

	return currencies.get(`${currency}-${digits}`);
}

interface FormatPriceArgs {
	amount: number | undefined;
	currency: string;
	language: string;
	digits?: number;
}

export function formatPrice({ amount, currency, language, digits = 0 }: FormatPriceArgs): string {
	const numberFormat = getNumberFormatter(language, currency, digits);
	return numberFormat.format(amount);
}

export function formatToPartsPrice({
	amount,
	currency,
	language,
	digits = 0,
}: FormatPriceArgs): { type: string; value: string }[] {
	const numberFormat = getNumberFormatter(language, currency, digits);
	return numberFormat.formatToParts(amount);
}

export function formatPriceInTwoParts({ amount, currency, language, digits = 0 }: FormatPriceArgs): { currency: string; amount: string; currencyAbbreviation: string } {
	const numberFormat = getNumberFormatter(language, currency, digits);
	const parts = numberFormat.formatToParts(amount);

	const currencyPart = parts.find((part: { type: string }) => part.type === 'currency');
	const currencyAbbreviation = new Intl.NumberFormat(language, {
		style: 'currency',
		currency,
		maximumFractionDigits: digits,
		minimumFractionDigits: 0,
		currencyDisplay: 'name',
	}).formatToParts(amount).find((part: { type: string }) => part.type === 'currency');
	const amountPart = parts.filter((part: { type: string }) => part.type !== 'currency');

	return {
		currency: currencyPart?.value,
		amount: amountPart.map((part: { value: string }) => part.value).join(''),
		currencyAbbreviation: currencyAbbreviation?.value ?? '',
	};
}
